module.exports = __webpack_public_path__ + "Flag-388.cad1a4342b09775a6a82477905a14c2d.svg";